module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Regular.d264a2a5.otf";